import React, { useEffect, useState } from "react";
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  CircularProgress,
  Button,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import ClearIcon from "@mui/icons-material/Clear";
import { useSnackbar } from "notistack";
import { Clear } from "@mui/icons-material";

const INITIAL_VALUES = {
  title: "",
  last_name: "",
  description: "",
  categories: [],
  status: true,
  image: null,
  imagePreview: null,
  videoURL: "",
  post_code: "",
  email: "",
  password: "",
  contact_number: "",
};

export default function JobsFilter(props) {
  const {
    handleFilterChange,
    filterValues,
    onCloseDrawer,
    handleFilterClear,
    applyFilters,
    refreshList,
  } = props;
  console.log(props, "typeFiltertypeFiltertypeFiltertypeFilter");

  const [submitting, setSubmitting] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  return (
    <form onSubmit={applyFilters} className="drawer-form">
      {/* Client Name Field */}
      <TextField
        fullWidth
        margin="normal"
        name="clientName"
        label="Company Name"
        value={filterValues.clientName || ""}
        onChange={handleFilterChange}
        sx={{ mb: 1, mt: 1 }}
      />
      {/* Location Field */}
      <TextField
        fullWidth
        margin="normal"
        name="location"
        label="Location"
        value={filterValues.location || ""}
        onChange={handleFilterChange}
        sx={{ mb: 1, mt: 1 }}
      />
      {/* Min Salary Field */}
      <TextField
        fullWidth
        margin="normal"
        name="minSalary"
        label="Min Salary"
        type="number"
        step="any"
        value={filterValues.minSalary || ""}
        onChange={handleFilterChange}
        sx={{ mb: 1, mt: 1 }}
      />
      {/* Max Salary Field */}
      <TextField
        fullWidth
        margin="normal"
        name="maxSalary"
        label="Max Salary"
        type="number"
        step="any"
        value={filterValues.maxSalary || ""}
        onChange={handleFilterChange}
        sx={{ mb: 1, mt: 1 }}
      />
      {/* Existing fields below */}
      <FormControl fullWidth margin="normal" sx={{ mb: 1, mt: 1 }}>
        <InputLabel>Job Type</InputLabel>
        <Select
          name="jobType"
          value={filterValues.jobType}
          onChange={handleFilterChange}
          label="Job Type"
        >
          <MenuItem value="Contract">Contract</MenuItem>
          <MenuItem value="Temporary">Temporary</MenuItem>
          <MenuItem value="Permanent">Permanent</MenuItem>
          <MenuItem value="Remote">Remote</MenuItem>
          <MenuItem value="Hybrid">Hybrid</MenuItem>
        </Select>
      </FormControl>
      <FormControl fullWidth margin="normal" sx={{ mb: 1, mt: 1 }}>
        <InputLabel id="experience-label">Experience Required</InputLabel>
        <Select
          labelId="experience-label"
          name="experience"
          value={filterValues.experience}
          onChange={handleFilterChange}
          label="Experience Required"
        >
          <MenuItem value="1year">1 Year</MenuItem>
          <MenuItem value="1to3year">1-3 Years</MenuItem>
          <MenuItem value="3to5year">3-5 Years</MenuItem>
          <MenuItem value="5to7year">5-7 Years</MenuItem>
          <MenuItem value="7to10year">7-10 Years</MenuItem>
          <MenuItem value="10plusyears">10+ Years</MenuItem>
        </Select>
      </FormControl>

      <FormControl fullWidth margin="normal" sx={{ mb: 1, mt: 1 }}>
        <InputLabel id="education-label">Education Required</InputLabel>
        <Select
          labelId="education-label"
          name="education"
          value={filterValues.education}
          onChange={handleFilterChange}
          label="Education Required"
        >
          <MenuItem value="no_minimum_required">No Minimum Required</MenuItem>
          <MenuItem value="third_level_certificate">
            Third level Certificate
          </MenuItem>
          <MenuItem value="junior_certificate">Junior Certificate</MenuItem>
          <MenuItem value="leaving_certificate">Leaving Certificate</MenuItem>
          <MenuItem value="third_level_diploma">Third Level Diploma</MenuItem>
          <MenuItem value="third_level_degree">Third Level Degree</MenuItem>
          <MenuItem value="phd">PHD</MenuItem>
          <MenuItem value="masters">Masters</MenuItem>
          <MenuItem value="post_graduate_qualification">
            Post Graduate Qualification
          </MenuItem>
          <MenuItem value="professional_qualification">
            Professional Qualification
          </MenuItem>
          <MenuItem value="part_professional_qualification">
            Part Professional Qualification
          </MenuItem>
          <MenuItem value="trade_qualification">Trade Qualification</MenuItem>
        </Select>
      </FormControl>
      <FormControl fullWidth margin="normal" sx={{ mb: 1, mt: 1 }}>
        <InputLabel id="frequency-label">Frequency Salary</InputLabel>
        <Select
          labelId="frequency-label"
          name="frequency"
          value={filterValues.frequency}
          onChange={handleFilterChange}
          label="Frequency Salary"
        >
          <MenuItem value="Hourly">Hourly</MenuItem>
          <MenuItem value="Daily">Daily</MenuItem>
          <MenuItem value="Weekly">Weekly</MenuItem>
          <MenuItem value="Monthly">Monthly</MenuItem>
          <MenuItem value="Yearly">Yearly</MenuItem>
        </Select>
      </FormControl>
      <FormControl fullWidth margin="normal" sx={{ mb: 1, mt: 1 }}>
        <InputLabel id="date-filter-label">Filter by Date</InputLabel>
        <Select
          labelId="date-filter-label"
          name="dateFilter"
          value={filterValues.dateFilter || ""}
          onChange={handleFilterChange}
          label="Filter by Date"
        >
          <MenuItem value="last24hours">Last 24 hours</MenuItem>
          <MenuItem value="last3days">Last 3 days</MenuItem>
          <MenuItem value="last7days">Last 7 days</MenuItem>
          <MenuItem value="last14days">Last 14 days</MenuItem>
          <MenuItem value="custom">Custom Dates</MenuItem>
        </Select>
      </FormControl>
      {/* Show start and end date fields if Custom Dates is selected */}
      {filterValues.dateFilter === "custom" && (
        <>
          <TextField
            fullWidth
            margin="normal"
            name="startDate"
            label="Start Date"
            type="date"
            value={filterValues.startDate || ""}
            onChange={handleFilterChange}
            InputLabelProps={{ shrink: true }}
            sx={{ mb: 1, mt: 1 }}
          />
          <TextField
            fullWidth
            margin="normal"
            name="endDate"
            label="End Date"
            type="date"
            value={filterValues.endDate || ""}
            onChange={handleFilterChange}
            InputLabelProps={{ shrink: true }}
            sx={{ mb: 1, mt: 1 }}
          />
        </>
      )}
      <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
        <Button
          startIcon={<FilterListIcon />}
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
        >
          Apply
        </Button>
        <Button
          startIcon={<Clear />}
          onClick={handleFilterClear}
          variant="outlined"
          color="primary"
          fullWidth
        >
          Clear
        </Button>
      </div>
    </form>
  );
}
